import React from 'react';
import UserDashboard from '../../Dashboard/Dashboard/Dashboard';

const Blog = () => {
    return (
        <div>
            <UserDashboard/>
            <div>
                <p className="mt-5 p-5 w-50 mx-auto text-danger" style={{fontSize: "30px"}}>This section is underdevelopment</p>
            </div>
        </div>
    );
};

export default Blog;